import { getFetchedDataPayload } from '../../../../../utils/fetched-data/get-fetched-data-payload';
import { loyaltyDomainStore } from '../../../store';
import { getLoyaltyGenresByIds } from './get-loyalty-genres-by-ids';
export const getAllLoyaltyGenres = () => {
    var _a;
    const genreIds = (_a = getFetchedDataPayload(loyaltyDomainStore.data.masterData)) === null || _a === void 0 ? void 0 : _a.genreIds;
    return genreIds ? getLoyaltyGenresByIds(genreIds) : undefined;
};
